/**
 * TutorialPromptModal — the one-time offer, shown in place of the create dialog.
 *
 * Every user meets this once, existing accounts included, because the flag it
 * reads starts absent for everyone.
 *
 * On a phone it offers only the skip, since the beginner tutorial is written
 * around dragging tiles onto the canvas and that is not how the mobile editor
 * works. Saying so is better than starting a tour whose instructions are wrong.
 */

import React from 'react';
import styles from './TutorialModal.module.css';

const TutorialPromptModal = ({ content, isMobile, onPlay, onSkip }) => (
    <div className={styles.modalOverlay} data-tutorial-ui="prompt">
        <div className={styles.modalContent} role="dialog" aria-modal="true" aria-label={content.title}>
            <h2 className={styles.modalTitle}>{content.title}</h2>
            <p className={styles.modalDescription}>{content.body}</p>
            <p className={styles.modalNote}>{isMobile ? content.mobileNote : content.note}</p>

            <div className={styles.buttonGroup}>
                {!isMobile && (
                    <button
                        type="button"
                        className={`${styles.buttonBase} ${styles.primaryButton}`}
                        onClick={onPlay}
                    >
                        {content.play}
                    </button>
                )}
                <button
                    type="button"
                    className={`${styles.buttonBase} ${
                        isMobile ? styles.primaryButton : styles.secondaryButton
                    }`}
                    onClick={onSkip}
                >
                    {isMobile ? content.mobileSkip : content.skip}
                </button>
            </div>
        </div>
    </div>
);

export default TutorialPromptModal;
